export default "__VITE_ASSET__BtNvKees__"